var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9463 16.6582H21.4426",
    stroke: "#3F3F3F",
    strokeWidth: 1.66584,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9463 19.1562H18.9438",
    stroke: "#3F3F3F",
    strokeWidth: 1.66584,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1104 9.99512C22.7104 9.99512 26.4395 13.7241 26.4395 18.3242C26.4395 22.9243 22.7104 26.6533 18.1104 26.6533C17.0404 26.6533 16.0195 26.452 15.082 26.0859C14.5587 25.8816 13.8814 25.9079 13.3174 25.96C12.7159 26.0155 12.0212 26.1283 11.4023 26.2168C10.7559 26.3092 10.1805 26.3771 9.72266 26.3711C9.49566 26.3681 9.33188 26.347 9.22168 26.3174C9.18725 26.3081 9.16393 26.2969 9.14746 26.29C9.13939 26.2409 9.12994 26.1232 9.16699 25.8906C9.2291 25.5007 9.38459 25.0127 9.58203 24.4424C9.76884 23.9028 9.99556 23.2838 10.1406 22.7314C10.275 22.2197 10.4047 21.5497 10.2119 20.9746C9.93305 20.1431 9.78125 19.2522 9.78125 18.3242C9.78125 13.7242 13.5103 9.99521 18.1104 9.99512Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.66584
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/reviewIcon.bf25b840c1ee16bfd7020742f2dd399b.svg";
export { ForwardRef as ReactComponent };